<template>
  <div class="page-index">
    <div class="header">
      <div class="Container">
        <h1>UCL SpaceTimeLab</h1>
        <h2>伦敦大学时空大数据实验室</h2>
        <a
          href="https://www.ucl.ac.uk/civil-environmental-geomatic-engineering/research/groups-centres-and-sections/spacetimelab"
          >About us</a
        >
      </div>
    </div>

    <div class="body">
      <div class="half column row">
        <div class="Container">
          <img src="../assets/img/stl_logo.png" style="width: 70%" />
        </div>

        <div class="Container">
          <h2>Historical crime dashboard</h2>
          <button type="submit" form="dashboard" value="Submit" @click="PUSH({name: 'history'})">Chicago</button>
          <p>enter historical crime dashboard (Chicago)</p>
        </div>

        <div class="Container">
          <h2>Crime prediction dashboard</h2>
          <button type="submit" form="fire_forecast" value="Submit" @click="PUSH({name: 'side'})">
            Chicago
          </button>
          <p>enter crime prediction dashboard (Chicago)</p>
        </div>
      </div>

      <div class="half column Container">
        <img src="../assets/img/mix_ucl_spacetimelab.jpg" style="width: 76%" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss">
.page-index {
  h1,
  h2 {
    font-weight: bold;
  }
  h1 {
    font-size: 0.4rem;
  }
  h2 {
    margin: 10px;
    font-size: 0.3rem;
  }
  .header {
    align-items: center;
  }

  .Container {
    border-radius: 5px;
    background-color: #f9f9f9;
    margin: 10px;
    padding: 15px;
    position: relative;
    box-shadow: 2px 2px 2px lightgrey;
    text-align: center;
    a {
      text-decoration: underline;
      font-size: 0.16rem;
    }
    button {
      margin: 10px 0;
    }
    p {
      font-size: 0.14rem;
    }
  }

  .column,
  .columns {
    width: 100%;
    align-items: center;
    box-sizing: border-box;
  }

  .body {
    display: flex;
  }
}
</style>